/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ATCONSTANTS as ATC } from 'appconstants';
import { FasArrowRight } from 'assets/icons';
import { getToken } from '@ctsu/loader';

function IRBApprovalModal({ data, onIRBRowClick }) {
  const columns = [
    { label: 'Institution CTEP ID', name: 'ctepId' },
    { label: 'Protocol', name: 'protocolNumber' },
    { label: 'Approval Type', name: 'approvalType' },
    { label: 'Version Date', name: 'versionDate' },
    { label: 'Approval Date', name: 'approvalDate' },
    { label: 'Signatory', name: 'sigSiteCtepId' },
    {
      label: 'Action',
      name: 'action',
      renderCell: (row) => (
        <button
          type="button"
          id="siteGo"
          className="fn-btn turquoise mr-1"
          data-id={`${ATC.SRBID}${row.id}_GO${ATC.BUTTON}`}
          onClick={(e) => {
            onIRBRowClick(row);
            e.stopPropagation();
          }}
          title="Go"
        >
          <FasArrowRight />
        </button>
      )
    }
  ];

  return (
    <>
      <div>
        There are multiple IRB records in this packet for this institution-protocol combination. Please select a
        specific approval below.
      </div>
      <GridTable
        tag={`${ATC.PACKETID}IRB_APPROVAL_MODAL_DATA${ATC.TABLE}`}
        id="irbApprovalModalData"
        rows={data}
        columns={columns}
        recordPerPage={5}
        onRowClicked={onIRBRowClick}
        toPdf={false}
        getToken={getToken}
      />
    </>
  );
}

export default IRBApprovalModal;
